<template>
  <div class="productDetails">
    <div class="boxCenter">
      <div class="productIntroduce">
        <div class="imgBox">
          <div class="bigImgBox"><img :src="curShowImg" alt="TINDOE坦途"/></div>
          <div class="imgItems">
            <div class="item" v-for="(item,index) in imgList" :key="index" @click="curShowImgSwitch(item)"><img :src="item.picUrl" alt="TINDOE坦途"/></div>
          </div>
          <!--<div class="signNum"><span class="spanBlod">3.26万</span>人浏览 &nbsp;&nbsp;&nbsp; <span class="spanBlod">956 人</span>已报名  &nbsp;&nbsp;&nbsp;  <span class="spanRed">[复制]</span> &nbsp;&nbsp;&nbsp; <span class="collection">收藏</span> &nbsp;&nbsp;&nbsp; <span class="phonePurchase">手机购买</span></div>-->
        </div>
        <div class="infoBox">
          <div class="title"><span>热销</span> &nbsp;&nbsp;{{dataObj.name}}</div>
          <div class="slogan">{{dataObj.intro}}</div>
          <div class="price">
            <p class="p1"><span class="span1">商品价格：</span><span style="font-size: 18px;margin-right: 4px;">¥</span>{{parseFloat(dataObj.price || 0).toFixed(2)}}</p>
            <p class="p2"><span class="span1">会员价格：</span><span style="font-size: 18px;margin-right: 4px;">¥</span>{{parseFloat(dataObj.memberPrice || 0).toFixed(2)}}</p>
            <div class="integral">可获得积分：{{dataObj.points}}</div>
          </div>
          <div class="goodsPropertyShows">
           <!--  <p class="title">商品属性:</p> -->
            <div class="item" v-for="(item,index) in goodsPropertyShows" :key="index">
              <div class="itemTh">{{item.propertyName}}</div> 
              <div class="itemTd"><span v-for="(child,k) in item.propertyVelues" :class="item.selected == child ? 'active' : ''" :key="k" @click="selectProper(item,child)">{{child}}</span></div>
            </div>
          </div>
          <div class="attrBox">
            <div class="attrTh">购买数量</div>
            <div class="attrTd">
              <el-input-number v-model="num" @change="handleChange" :min="1" :max="50"></el-input-number>
            </div>
          </div>
          <div class="attrBox" v-for="(item,index) in dataObj.properties" :key="index">
            <div class="attrTh">{{item.name}}：</div>
            <div class="attrTd"><span class="desItem" v-for="(row,num) in item.properArr" :key="num">{{row}}</span></div>
          </div>
          
          <div class="address">
            <span style="margin-right: 43px;">店铺地址 </span>
            <el-select v-model="addressCurrent" placeholder="请选择店铺地址" style="min-width:400px" @change="getGoodsStock" filterable>
              <el-option v-for="(item,index) in address" :key="index" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </div>
          <div class="attrBox" v-if="addressStock !== null">
            <div class="attrTh">店铺库存</div>
            <div class="attrTd" style="line-height:30px; ">
              {{addressStock}}
            </div>
          </div>
          <div class="addCar"><el-button @click="addToCar">加入购物车</el-button></div>
        </div>
      </div>
      <div class="proInfoBox">
        <!--<div class="tabTh">-->
          <!--<div class="tabThItem" :class="{'active':tabType == 1}" @click="contentInfoChange(1)">产品参数</div>-->
          <!--<div class="tabThItem" :class="{'active':tabType == 2}" @click="contentInfoChange(2)">商品详情</div>-->
        <!--</div>-->
        <div class="tabTd">
          <div class="tabTdItem">
            <div class="title">商品详情</div>
            <div class="content" v-html="dataObj.descs"></div>
          </div>
        </div>
        <div class="tabTd">
          <div class="tabTdItem">
            <div class="title">商品评价</div>
            <div class="content">
              <div class="rateBox" v-for="(item,index) in evaluationList" :key="index">
                <div><el-rate v-model="item.star" :disabled="true"></el-rate></div>
                <div class="Rcontent">{{item.desc}}</div>
                <div class="author">{{item.nickname}} {{item.createDate?item.createDate.substring(0,19):''}}</div>
                <el-divider></el-divider>
              </div>
              <div style="padding:10px;text-align: center">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :current-page="curPage"
                  :page-size="10"
                  :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="newProductList">
        <div class="title">关联活动</div>
        <ul>
          <li v-for="(item,index) in recommendGoods" :key="index">
            <router-link :to="'/productDetails/'+item.id">
            <img :src="item.pic" alt="TINDOE坦途"/>
            <p class="price"><span>¥</span> {{item.price}}</p>
            </router-link>
          </li>
        </ul>
      </div> -->
      <div class="newList">
        <div class="title">推荐活动</div>
        <ul>
          <li v-for="(item,index) in dataObj.travels" :key="index">
            <router-link :to="'/activitieDetails/'+item.id">
            <img :src="item.pic" alt="TINDOE坦途"/>
            </router-link>
            <div class="slogin">{{item.themName}} | {{item.startLocation}} {{item.classify == 1 ? '' : '出发'}}</div>
            <div class="info">
              <div class="des">{{item.name}}</div>
              <div class="price">
                <p>{{item.signUp}}人已报名</p>
                <p><span class="span1">¥ </span>{{item.childPrice > 0 ? item.childPrice.toFixed(2) : item.price.toFixed(2)}}<span class="span2"> 元起</span></p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import eventVue from '../bus.js'
  export default {
    data(){
      return {
        //userId:9,
        num:1,
        proId:'',//商品ID
        imgList:[], //图片列表
        curShowImg:'',
        dataObj:{
          name:''
        },
        // 店铺地址和库存
        address:'',
        addressCurrent : '',
        addressStock : null,

        recommendGoods:[],
        descsImg:[],
        goodsPropertyShows:[],
        propertyArr:[],//选中的属性

        evaluationList:[],
        curPage:1,
        total:0,
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    mounted(){
      this.proId = this.$route.params.id
      this.loadDataInfo()
      this.getEvaluation()
      this.recommendTourismList()
    },
    methods:{
      // contentInfoChange(type){
      //   this.tabType = type
      // },
      handleCurrentChange(val){
        this.curPage = val
        this.getEvaluation()
      },
      //图片点击切换显示
      curShowImgSwitch(item){
        this.curShowImg = item.picUrl
      },
      //获取商品信息详情
      loadDataInfo(){
        this.$https.get('/api/goods/id/'+this.proId).then((response)=>{
          this.dataObj = response.data
          if (response.data.goodsPropertyShows && response.data.goodsPropertyShows.length > 0) {
            response.data.goodsPropertyShows.map((item,index)=>{
              //默认不选中
              item.selected = null
              //如果单个的话就选中
              if(item.propertyVelues && item.propertyVelues.length === 1){
                item.selected = item.propertyVelues[0]
              }
            })
            //产品的尺码规格等信息
            this.goodsPropertyShows = response.data.goodsPropertyShows
          }
          //产品价格等信息
          this.goodsPropertyPrices = response.data.goodsPropertyPrices || []
          this.loadAddress()
          this.imgList = response.data.goodsPics
          this.curShowImg = response.data.pic
          //富文本内容 如果没有标签
          var pattern = /<("[^"]*"|'[^']*'|[^'">])*(>|$)|\s+/g;
          if (response.data.descs && response.data.descs.split(',').length > 0 && !pattern.test(response.data.descs)) {
              var html = "<p>"
              response.data.descs.split(',').forEach(url => {
                html += "<img src='"+url+"' alt=''  data-href='' style='width:100%; display:block; margin:10px auto; height:auto;' />"
              })
              html += "</p>"
              response.data.descs = html
          }
          if(response.data.properties && response.data.properties.length>0){
            response.data.properties.forEach((item)=>{
              let arr = item.valueInfo.split(',')
              item.properArr = arr
            })
          }
        }).catch((error) => {});
      },
      //推荐商品
      recommendTourismList(){
        this.$https.get('/api/goods/recommend/count/6').then((response)=>{
          this.recommendGoods = response.data
        });
      },
      //获取商品评价列表
      getEvaluation(){
        this.$https.get('/api/goodsEvaluation/pageIndex/'+this.curPage+'/pageNum/10?goodsId='+this.proId).then((response)=>{
          this.evaluationList = response.data.records
          this.total = response.data.total
        });
      },
      //获取店铺地址
      loadAddress(){
        this.$https.get('/api/shop').then(res=>{
          this.address = res.data || []
          if(this.address.length > 0){
            this.addressCurrent = this.address[0].id
          }
          
        })
        // this.$https.get('/api/config').then((response)=>{
        //   //this.dataObj = response.data
        //   for(let i=0;i<response.data.length;i++){
        //     let item = response.data[i]
        //     if(item.id == 4){
        //       this.address =  item.msg
        //       continue
        //     }
        //   }
        // }).catch((error) => {

        // });
      },
      selectProper(item,child){
        item.selected = child
        this.$forceUpdate()
        
        
        //拿价格、库存数据
        this.getGoodsStock()
      },
     
      //拿价格、库存数据
      getGoodsStock(){
        if(!this.addressCurrent){
          return;
        }
        //检查属性是否都选；
        var bool = true
        var sku = []
        for(var i = 0; i<this.goodsPropertyShows.length ;i++){
          var item = this.goodsPropertyShows[i]
          if(!item.selected){
            bool = false
            break;
          }
          if(item.selected){
            sku.push(item.selected)
          }
        }
        if(!bool) return;
        //得到的选中属性
        this.propertyArr = sku
        //查价格
        if(this.goodsPropertyPrices && this.goodsPropertyPrices.length > 0 && this.goodsPropertyPrices.find(c=>c.sku == sku.join(','))){
          var obj = this.goodsPropertyPrices.find(c=>c.sku == sku.join(','))
          this.dataObj.price = obj.price || 0
          this.dataObj.memberPrice = obj.memberPrice || 0
        }
        //拿库存
        this.$https.get(`/api/goods/getGoodsStock?shopId=${this.addressCurrent}&goodsId=${this.proId}&sku=${sku.join(',')}`).then((res)=>{
          this.addressStock = res.data || 0
        })

      },
      //添加购物车
      addToCar(){
        if(!this.userData){
          eventVue.$emit("callLogin")
          return
        }
        if (!this.propertyArr || this.propertyArr.length === 0 || this.propertyArr.length != this.goodsPropertyShows.length) {
          this.$message.warning('请先选择属性')
          return
        }
        if(!this.addressStock || isNaN(this.addressStock) || parseInt(this.addressStock) < parseInt(this.num)){
          this.$message.warning('抱歉，库存不足')
          return;
        }
        let data =  {
          goodsId: this.proId,
          memberId: this.userData.id,
          memberPrice: this.dataObj.memberPrice,
          name:this.dataObj.name,
          num:this.num,
          pic:this.dataObj.pic,
          price:this.dataObj.price,
          property:this.propertyArr.join(','),
          goodsCode:this.dataObj.code,
          points:this.dataObj.points,
          shopId : this.addressCurrent
        }
        this.$https.post('/api/cart/addCart',data).then((response)=>{
          if(response.code === 0){
              this.$message.success('加入成功')
          }else{
              this.$message.warning(response.message || response.msg)
          }
        }).catch((error) => {});
      },
      //选择数量
      handleChange(val){

      }
    }
  }
</script>

<style scoped>
  .rateBox .Rcontent{
    padding:10px 0;
    color:#666666
  }
  .rateBox .author{
    color:#333333;
    font-size:12px;
  }
  .addCar{
    padding-left: 130px; padding-top:20px;
  }
  .goodsPropertyShows{
    padding: 0 30px;
  }
  .goodsPropertyShows .item{
    line-height: 30px;
    margin-top: 15px;
  }
  .goodsPropertyShows .itemTh{
    float: left;
    width: 95px;
    height: 30px;
    overflow: hidden;
    font-size: 13px;
    color: #363636;
  }
  .goodsPropertyShows .itemTd{
    padding-left: 100px;
  }
  .goodsPropertyShows .itemTd span{
    display: inline-block;
    height: 28px;
    padding: 0 13px;
    border: 1px solid #cdcdcd;
    font-size: 13px;
    color: #363636;
    cursor: pointer;
    position: relative;
    margin-right: 7px;
  }
  .goodsPropertyShows .itemTd span.active{
    border: 1px solid #ffcd30;
    background: url("../assets/images/properSelected.png") no-repeat right bottom;
  }

  .productIntroduce{
    padding-top: 15px;
    overflow: hidden;
  }
  .imgBox{
    float: left;
    width: 503px;
  }
  .imgBox .bigImgBox{
    width: 503px;
    height: 503px;
  }
  .imgBox img{
    width: 100%;
    height: 100%;
  }
  .imgBox .imgItems{
    overflow: hidden;
    padding-top: 4px;
  }
  .imgBox .imgItems .item{
    float: left;
    width: 95px;
    height: 95px;
  }
  .imgBox .imgItems .item+.item{
    margin-left: 7px;
  }
  .imgBox .signNum{
    line-height: 47px;
    font-size: 13px;
    color: #363636;
  }
  .imgBox .signNum .spanBlod{
    font-weight: bold;
  }
  .imgBox .signNum .spanRed{
    color: #fe5a43;
  }
  .imgBox .signNum .collection{
     padding-left: 21px;
     background: url("../assets/images/aixin.png") no-repeat left center;
   }
  .imgBox .signNum .phonePurchase{
    padding-left: 14px;
    background: url("../assets/images/shouji.png") no-repeat left center;
  }
  .infoBox{
    float: left;
    width: 697px;
  }
  .infoBox .title{
    padding-left: 25px;
    padding-top: 2px;
    max-height: 60px;
    line-height: 30px;
    font-size: 20px;
  }
  .infoBox .title span{
    float: left;
    font-weight: normal;
    line-height: 28px;
    padding: 0 10px;
    background: #ffcd30;
    color: #ffffff;
    font-size: 14px;
    border-radius: 3px;
  }
  .infoBox .slogan{
    height: 21px;
    line-height: 21px;
    font-size: 15px;
    color: #5680f9;
    padding-left: 25px;
  }
  .infoBox .price{
    height: 84px;
    line-height: 84px;
    background: url("../assets/images/proPriBg.png") no-repeat;
    margin-top: 6px;
    position: relative;
    margin-left: 26px;
  }
  .infoBox .price p{
    float: left;
  }
  .infoBox .price .p1{
    font-size: 32px;
    color: #ffcd30;
    margin-left: 5px;
  }
  .infoBox .price .p1 span{
    font-size: 13px;
  }
  .infoBox .price .p1 .span1{
    color: #363636;
    margin-right: 5px;
    font-weight: normal;
  }
  .infoBox .price .p2{
    font-size: 32px;
    color: #e40000;
    margin-left: 28px;
  }
  .infoBox .price .p2 span{
    font-size: 13px;
  }
  .infoBox .price .p2 .span1{
    color: #363636;
    margin-right: 5px;
    font-weight: normal;
  }
  .infoBox .price .integral{
    position: absolute;
    right: 0px;
    bottom: 0px;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    background: #ffcd30;
    border-top-left-radius: 9px;
    color: #ffffff;
    font-size: 13px;
  }
  .attrBox{
    overflow: hidden;
    margin-top: 14px;
  }
  .attrBox .attrTh{
    padding-left: 30px;
    margin-right: 48px;
    line-height: 30px;
    float: left;
    font-size: 13px;
    color: #363636;
  }
  .attrBox .attrTd{
    float: left;
    overflow: hidden;
  }
  .attrBox .attrTd .imgItem{
    float: left;
    width: 46px;
    height: 46px;
    border: 1px solid #cdcdcd;
    margin-right: 7px;
  }
  .attrBox .attrTd .imgItem.active{
    border: 1px solid #ffcd30;
  }
  .attrBox .attrTd .imgItem img{
    width: 100%;
    height: 100%;
  }
  .attrBox .attrTd .desItem{
    float: left;
    padding: 0 15px;
    height: 28px;
    line-height: 28px;
    border: 1px solid #cdcdcd;
    margin-right: 7px;
    font-size: 13px;
    color: #363636;
  }
  .attrBox .attrTd .desItem.active{
    border: 1px solid #ffcd30;
  }
  .infoBox .address{
    height: 43px;
    line-height: 43px;
    padding-left: 30px;
    font-size: 13px;
    color: #363636;
    clear:both;
    margin-top: 7px;
  }
  .infoBox .totalPrice{
    height: 55px;
    line-height: 55px;
    background: #f8f8f8;
    font-size: 13px;
    color: #363636;
  }
  .infoBox .totalPrice .num{
    float: left;
    padding-left: 30px;
  }
  .infoBox .totalPrice .tp{
    float: right;
  }
  .infoBox .totalPrice .tp .buyBtn{
    display: inline-block;
    width: 124px;
    height: 38px;
    border-radius: 3px;
    background: #ffcd30;
    line-height: 38px;
    text-align: center;
    margin-right: 7px;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
  }
  .proInfoBox{
    padding: 22px 0;
  }
  .proInfoBox .tabTh{
    border:1px solid #5680f9;
    border-top:2px solid #5680f9;
    height: 32px;
    background: #f4f7ff;
  }
  .proInfoBox .tabTh .tabThItem{
    float: left;
    height: 21px;
    line-height: 21px;
    padding: 0 15px;
    border-radius: 21px;
    font-size: 15px;
    color: #363636;
    margin: 5px 0 0 30px;
    cursor: pointer;
  }
  .proInfoBox .tabTh .tabThItem.active{
    color: #ffffff;
    background: #5680f9;
  }
  .proInfoBox .tabTd{
    margin-top:11px;
  }
  .proInfoBox .tabTdItem{
    background: #f6f5f5;
    border:1px solid #cdcdcd;
  }
  .proInfoBox .tabTdItem .title{
    height: 44px;
    line-height: 44px;
    border-bottom:2px solid #5680f9;
    padding: 0 72px;
    font-size: 15px;
    color: #363636;
  }
  .proInfoBox .tabTdItem .content{
    background: #fff;
    padding: 30px;
    line-height: 25px; 
    word-break: break-all; word-wrap: break-word;
  }
  .proInfoBox .tabTdItem .content *{
    word-break: break-all; word-wrap: break-word;
  }
  .contentTable{
    width: 100%;
  }
  .contentTable td{
    line-height: 40px;
    font-size: 13px;
    color: #363636;
  }
  .newProductList{
  }
  .newProductList .title{
    height: 46px;
    line-height: 46px;
    padding: 0 35px;
    background: #5680f9;
    color: #ffffff;
    font-size: 17px;
  }
  .newProductList ul{
    padding-top: 12px;
    width: 1233px;
    margin-left: -33px;
    overflow: hidden;
  }
  .newProductList ul li{
    width: 378px;
    height: 378px;
    float: left;
    margin: 0 0 33px 33px;
    background: #ffffff;
    position: relative;
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.05);
  }
  .newProductList ul li img{
    width: 100%;
    height: 100%;
  }
  .newProductList .price{
    width: 308px;
    height: 56px;
    line-height: 56px;
    padding: 0 35px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    font-size: 30px;
    color: #ffcd30;
  }
  .newProductList .price span{
    font-size: 15px;
  }
  .propertyBox{}
  .propertyBox .itemBox{}
  .propertyBox .itemBox .itemTd{}
  .propertyBox .itemBox .active{color: red}


  .newList{
  }
  .newList .title{
    height: 46px;
    line-height: 46px;
    padding: 0 35px;
    background: #5680f9;
    color: #ffffff;
    font-size: 17px;
  }
  .newList ul{
    width: 1233px;
    margin-left: -33px;
    overflow: hidden;
    padding-bottom: 30px;
  }
  .newList ul li{
    float: left;
    width: 378px;
    height: 203px;
    margin: 12px 0 0 33px;
    position: relative;
  }
  .newList img{
    width: 100%;
    height: 100%;
  }
  .newList .slogin{
    position: absolute;
    top: 11px;
    left: 11px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #ffffff;
    border-radius: 32px;
    padding: 0 18px;
    background: rgba(0,0,0,0.5);
  }
  .newList .info{
    position: absolute;
    width: 318px;
    padding: 0 30px;
    right: 0px;
    bottom: 0px;
    height: 67px;
    background: rgba(0,0,0,0.5);
    color: #ffffff;
  }
  .newList .info .des{
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .newList .info .price{
    height: 30px;
    line-height: 30px;
    font-size: 13px;
  }
  .newList .info .price p{
    float: left;
  }
  .newList .info .price p+p{
    float: right;
    font-size: 32px;
    color: #ffcd30;
  }
  .newList .info .price p+p span{
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/productDetails.vue